import { useEffect, useRef } from "react";
import DOMPurify from "dompurify";
import { Bold, Italic, List, ListOrdered, Heading3, Link2, Eraser } from "lucide-react";

export function RichHtml({ html, className = "", testId }) {
  return <div className={`rich text-slate-700 ${className}`} data-testid={testId} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html || "") }} />;
}

const TOOLS = [
  { icon: Bold, cmd: "bold" },
  { icon: Italic, cmd: "italic" },
  { icon: Heading3, cmd: "formatBlock", arg: "h3" },
  { icon: List, cmd: "insertUnorderedList" },
  { icon: ListOrdered, cmd: "insertOrderedList" },
  { icon: Link2, cmd: "createLink" },
  { icon: Eraser, cmd: "removeFormat" },
];

export function RichEditor({ value, onChange, testId, placeholder = "Start typing…" }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
  }, [value]);

  const run = (t) => {
    ref.current.focus();
    let arg = t.arg;
    if (t.cmd === "createLink") {
      arg = window.prompt("Link URL");
      if (!arg) return;
    }
    document.execCommand(t.cmd, false, arg);
    onChange(ref.current.innerHTML);
  };

  return (
    <div className="rounded-md border border-[#E2DCD2] bg-white focus-within:border-[#C59B27]" data-testid={testId}>
      <div className="flex flex-wrap gap-1 border-b border-[#E2DCD2] p-1.5 bg-[#F9F6F0]">
        {TOOLS.map((t) => (
          <button key={t.cmd + (t.arg || "")} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => run(t)}
            className="h-8 w-8 rounded flex items-center justify-center text-[#3E5C4E] hover:bg-white hover:text-[#0F2E23]" data-testid={`${testId}-tool-${t.cmd}${t.arg ? "-" + t.arg : ""}`}>
            <t.icon className="h-4 w-4" />
          </button>
        ))}
      </div>
      <div
        ref={ref} contentEditable suppressContentEditableWarning data-placeholder={placeholder}
        onInput={() => onChange(ref.current.innerHTML)}
        className="rich rich-editor min-h-[140px] p-4 text-sm text-slate-800 focus:outline-none"
        data-testid={`${testId}-area`}
      />
    </div>
  );
}
